<template>
  <div class="pagination justify-content-between">
    <div id="page-number" class="text-green w-100 text-center">
      <button class="small btn btn-link"
              @click.prevent.stop="setPage(1)">
        << {{ $t('message.first') }}
      </button>
      <button class="small btn btn-link"
              @click.prevent.stop="setPage(activePage-1)">
        < {{ $t('message.previous') }}
      </button>
      <button class="small btn btn-link"
              v-if="prevLength[0] > 1">
        ...
      </button>
      <button v-for="page in prevLength"
              class="small btn btn-link"
              @click.prevent.stop="setPage(page)">
        {{page}}
      </button>
      <button class="small btn btn-link active disabled">
        {{activePage}}
      </button>
      <button v-for="page in nextLength"
              class="small btn btn-link"
              @click.prevent.stop="setPage(page)">
        {{page}}
      </button>
      <button class="small btn btn-link"
              v-if="nextLength[(nextLength.length-1)] < pagemax">
        ...
      </button>
      <button class="small btn btn-link"
              @click.prevent.stop="setPage(activePage+1)">
        {{ $t('message.next') }} >
      </button>
      <button class="small btn btn-link"
              @click.prevent.stop="setPage(pagemax)">
        {{ $t('message.last') }} >>
      </button>
    </div>
<!--<button @click="test">test</button>-->
  </div>
</template>
<script>
  export default {
    methods: {
      test(){
       // console.log(this)
      },
      setPage(page) {
        if (page > 0 && !(page > this.pagemax)) {
          this.$emit('setPage', page)
        }
      }
    },
    computed: {
      pagecount() {
        return this.activePage
      },
      pagemax() {
        return Math.ceil(this.resultCount / this.resultsPerpage)
      },
      prevLength() {
        let count = 2;
        let pages = [];
        for (let i = 1; i <= count; i++) {
          let page = this.activePage - i;
          if (page < this.activePage && page > 0) {
            pages.unshift(page)
          }
        }
        return pages;
      },
      nextLength() {
        let count = 2;
        let pages = [];
        for (let i = 1; i <= count; i++) {
          let page = this.activePage + i;
          if (page <= this.pagemax) {
            pages.push(page)
          }
        }
        return pages;
      },
    },
    props: {
      activePage: {
        type: Number,
        default() {
          return 1
        }
      },
      resultCount: {
        type: Number,
        default() {
          return 1
        }
      },
      resultsPerpage: {
        type: Number,
        default() {
          return 1
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Pager.vue